import time from '../../../server/utils/time.js'
import Colors from '../../../utils/Colors.js'
import {Reseller} from '../resellers/resellers.types.js'
import {Route} from './route.types.js'
import {resolveMessengerRouteSettings} from '../../../utils/routeAdjustability.js'

export default (reseller: Reseller): Route => {
    const defaultVehicleType = reseller?.settings.vehicleTypes.find((v) => v._id === reseller.settings.defaultVehicle)
    const messengerRouteSettings = resolveMessengerRouteSettings({adjustableByMessengerGrouped: 'default'}, reseller?.settings)

    const route: Route = {
        date: time.today(),
        messengerId: '',
        color: Colors.routeColors[Math.floor(Math.random() * Colors.routeColors.length)],
        name: '',
        plannedStartTime: '',
        startPoint: reseller?.settings ? {...reseller.settings.companyAddress} : {name: '', street: '', nr: '', addition: '', postalCode: '', city: ''},
        endPoint: reseller?.settings ? {...reseller.settings.companyAddress} : {name: '', street: '', nr: '', addition: '', postalCode: '', city: ''},
        vehicleType: defaultVehicleType?.routeProfile || 'bike',
        vehicleTypeId: defaultVehicleType?._id || '',
        vehicleId: '',
        stopTime: (reseller?.permissions.vehicles ? defaultVehicleType?.stopTime : reseller?.settings.stopTime) || 180,
        instructions: '',
        optimizeForTimeslots: !!reseller?.settings.optimizeForTimeslots,
        adjustableByMessengerGrouped: messengerRouteSettings.adjustableByMessengerGrouped,
        adjustableByMessenger: messengerRouteSettings.adjustableByMessenger,
        allowAddAddress: messengerRouteSettings.allowAddAddress,
        allowAddCollo: messengerRouteSettings.allowAddCollo,
        messengerAddOrderWarning: messengerRouteSettings.messengerAddOrderWarning,
        showWarningOnAddExistingOrder: messengerRouteSettings.showWarningOnAddExistingOrder,
        allowMessengerEditCustomOptions: messengerRouteSettings.allowMessengerEditCustomOptions,
        loadingRequiredBeforeStart: !!reseller?.settings.loadingRequiredBeforeStart,
        completedAddresses: [],
        completedColli: [],
        orderIds: []
    }

    if (defaultVehicleType?.speedDifferenceEnabled) {
        route.customSpeed = true
        const speedDifference = defaultVehicleType.speedDifferenceMode === 'faster' ? -defaultVehicleType.speedDifference : defaultVehicleType.speedDifference
        route.speedDifference = speedDifference
    }

    return JSON.parse(JSON.stringify(route))
}
